import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Link, useHistory, useParams } from "react-router-dom";

//UI
import { Form, Message, Breadcrumb, Divider, Loader, Header, Button } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

//Actions
import { createSpace } from "../../../../redux/actions/reservations/space/createSpace";
import { updateSpace } from "../../../../redux/actions/reservations/space/updateSpace";
import { initialStateSpace, } from "../../../../redux/actions/reservations/space/fetchSpace";
import { fetchSpaceFormCustom, initialStateSpaceFormCustom } from "../../../../redux/slices/custom/reservations/cruise/space/customSpaceForm.slice";
import { findRatesForSpace, initialStateFindRatesForSpace } from "../../../../redux/slices/custom/reservations/cruise/space/findRatesForSpace.slice";
//Components
import HeadDetail from "../../../../components/headDetail";
import HeadDetailReservation from "../../../../components/headDetailReservation";

// Resources
import { reservationStatus, passengerNationalities } from "../../../resources/optionsList";
import { scrollToTop } from "../../../resources/utils";

export default function SpaceForm() {

  let history = useHistory();
  let { cruise_id } = useParams();
  let { reservation_id } = useParams();
  let { booking_id } = useParams();
  let { space_id } = useParams();
  const { t } = useTranslation();

  const { register, handleSubmit, errors, setValue } = useForm();
  const [spaceStates, setSpaceState] = useState();
  const [disabled, setDisabled] = useState(true);
  const [isChangePassenger, setIsChangePassenger] = useState('');
  const [disabledState, setDisabledState] = useState(false);
  const [checketTicket, setChecketTicket] = useState(false);
  const [spaceValue, setSpaceValue] = useState('0.00');
  const bookingStateCustom = useSelector((state) => state.customSpaceForm);
  const findRatesState = useSelector((state) => state.findRatesForSpace);
  const spaceState = useSelector((state) => state.spaceReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchSpaceFormCustom(booking_id, cruise_id, reservation_id, space_id))
    scrollToTop();
    return () => {
      dispatch(initialStateSpaceFormCustom());
      dispatch(initialStateSpace());
      dispatch(initialStateFindRatesForSpace())
    };
  }, []);

  useEffect(() => {
    if (space_id && Object.keys(bookingStateCustom.space).length !== 0) {
      setIsChangePassenger(bookingStateCustom.space.gender_id);
      setSpaceValue(bookingStateCustom.space.price);
      setChecketTicket(bookingStateCustom.space.include_flight_ticket)
      setSpaceState(bookingStateCustom.space.state);
      setDisabled(bookingStateCustom.space.state === 'reserved' ? false : true);
      setValue("state", bookingStateCustom.space.state);
      setValue("time_limit", bookingStateCustom.space.time_limit);
      setValue("gender_id", bookingStateCustom.space.gender_id);
      setValue("passenger_nationality", bookingStateCustom.space.passenger_nationality);
      setValue("tour_leader", bookingStateCustom.space.tour_leader);
      setValue("tour_conductor", bookingStateCustom.space.tour_conductor);
      setValue("ticket", bookingStateCustom.space.ticket);
    }
  }, [bookingStateCustom.space, setValue, space_id]);

  useEffect(() => {
    if (bookingStateCustom.reservation.charter) {
      setValue("state", bookingStateCustom.reservation.charter_state);
      setValue("time_limit", bookingStateCustom.reservation.charter_time_limit);
      if (bookingStateCustom.reservation.include_flight_ticket) {
        setValue("ticket", bookingStateCustom.reservation.include_flight_ticket);
        setChecketTicket(bookingStateCustom.reservation.include_flight_ticket)
      }
      setDisabledState(true);
      setDisabled(true);
    }

    if (!bookingStateCustom.reservation.charter && bookingStateCustom.booking.family_room) {
      setValue("ticket", bookingStateCustom.booking.include_flight_ticket);
      setChecketTicket(bookingStateCustom.booking.include_flight_ticket)

    }
  }, [bookingStateCustom]);

  if (bookingStateCustom.fetching || spaceState.fetching) {
    return <Loader active inline />;
  }

  const onSubmit = (data) => {
    data["cruise_id"] = cruise_id;
    data["cabin_id"] = bookingStateCustom.booking.cabin_id;
    data["single"] = bookingStateCustom.booking.single;
    data["contract_rate"] = bookingStateCustom.reservation.contract_rate;
    data["ikarus_rate"] = bookingStateCustom.reservation.ikarus_rate;
    data["space_flight_ticket"] = bookingStateCustom.space.ticket;
    if (space_id) {
      data["reservation_id"] = reservation_id;
      data["booking_id"] = booking_id;
      dispatch(updateSpace(space_id, data));
    } else if (booking_id) {
      dispatch(createSpace(reservation_id, booking_id, data));
    }
  };

  if (spaceState.message === "resource created successfully" || spaceState.message === "resource updated successfully") {
    history.go(-1);
  }

  function calculateTimeLimitDays() {
    var currentDate = new Date();
    var startCruiseDateArray = bookingStateCustom.cruise.start_date_format.split("/");
    var startCruiseDate = new Date(startCruiseDateArray[1] + "/" + startCruiseDateArray[0] + "/" + startCruiseDateArray[2]);
    var differenceInTime = startCruiseDate.getTime() - currentDate.getTime();
    var differenceInDays = differenceInTime / (1000 * 3600 * 24);

    if (differenceInDays < 60) {
      return 3;
    }
    return 7;
  }

  const handleTimeLimitDate = (e) => {
    if (e === "reserved") {
      setDisabled(false);
      var currentDate = new Date();
      var timeLimitDate = new Date(currentDate.setDate(currentDate.getDate() + calculateTimeLimitDays()));
      var options = { year: "numeric", month: "2-digit", day: "2-digit" };
      setValue("time_limit", timeLimitDate.toLocaleDateString("es", options).split("/").reverse().join("-"));
    } else {
      setValue("time_limit", "");
      setDisabled(true);
    }
  };

  const handleChancePassengerType = (gender_id) => {
    setChecketTicket(false)
    setSpaceValue('0.00')
    setValue('ticket', false)
    setIsChangePassenger(gender_id)
    if (gender_id) {
      const query = (`?space_id=${space_id}&&cabin_id=${bookingStateCustom.booking.cabin_id}&&gender_id=${gender_id}&&contract_rate=${bookingStateCustom.reservation.contract_rate}`)
      dispatch(findRatesForSpace(reservation_id, booking_id, query))
    }
  }

  const hadleChecketTicket = (e) => {
    const checkTicket = findRatesState.rates.find(rate => rate.rateId === e.target.value)
    setChecketTicket(checkTicket.airplaneTicket)
    setSpaceValue(checkTicket.rateClientPrice)
    if (checkTicket.airplaneTicket) setValue('ticket', checkTicket.airplaneTicket)
  }

  return (
    <>
      {spaceState.error ? (
        <Message negative content={t(spaceState.error)} />
      ) :
        findRatesState.error ? (
          <Message negative content={t(findRatesState.error)} />
        ) : ""}
      <Breadcrumb>
        <Breadcrumb.Section><Link to={`/cruises/${cruise_id}/cruise-detail`} className="section">{bookingStateCustom.cruise.code}</Link></Breadcrumb.Section>
        <Breadcrumb.Divider />
        <Breadcrumb.Section><Link to={`/cruises/${cruise_id}/reservations`} className="section"> {t("reservation_title")}</Link></Breadcrumb.Section>
        <Breadcrumb.Divider />
        <Breadcrumb.Section><Link to={`/cruises/${cruise_id}/reservations/${reservation_id}/bookings`} className="section">  {t("cabin_title")}</Link></Breadcrumb.Section>
        <Breadcrumb.Divider />
        <Breadcrumb.Section active> {t("cabin_cabin")} {bookingStateCustom.booking.cabin_name}</Breadcrumb.Section>
        <Breadcrumb.Divider />
        <Breadcrumb.Section><Link to={`/cruises/${cruise_id}/reservations/${reservation_id}/bookings/${booking_id}/spaces`} className="section">  {t("space_title")}</Link></Breadcrumb.Section>
        <Breadcrumb.Divider />
        <Breadcrumb.Section active> {t("space_path")}</Breadcrumb.Section>
      </Breadcrumb>
      <Divider variant="fullWidth" />

      <HeadDetail
        yacht_name={bookingStateCustom.cruise.yacht_name}
        itinerary_name={bookingStateCustom.cruise.itinerary_name}
        cruise_name={bookingStateCustom.cruise.name}
        start_date={bookingStateCustom.cruise.start_date_format}
        end_date={bookingStateCustom.cruise.end_date_format}
      />

      <HeadDetailReservation
        reservation_date={bookingStateCustom.reservation.creation_date}
        reservation_agency={bookingStateCustom.reservation.agency_name}
        reservation_executive={bookingStateCustom.reservation.user}
        reservation_type={bookingStateCustom.reservation.cruise_type}
      />

      <br />
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Header as='h3' dividing>{t("general_information_tag")}</Header>
        <Form.Group widths="equal">
          <Form.Field required>
            <label>{t("space_state")}</label>
            <select aria-expanded="true" name="state" disabled={
              space_id && bookingStateCustom.space.state === "confirmed"
                ? true
                : disabledState === true
                  ? true
                  : false
            }
              ref={register({ required: true })}
              onChange={(e) => {
                setSpaceState(e.target.value);
                handleTimeLimitDate(e.target.value)
              }}
            >
              <option></option>
              {reservationStatus.map((reserveState, index) => (
                <option className="selected item" key={index} value={reserveState.value}>
                  {t(reserveState.name)}
                </option>
              ))}
            </select>
            {errors.state && (<span className="error_message">{t("required_information")}{" "}</span>)}
          </Form.Field>

          <Form.Field required={spaceStates === "reserved" ? true : false}>
            <label>{t("space_time_limit")}
              <span className="text_date_format"> (dd-mm-yyyy)</span>
            </label>
            <input type="date" disabled={disabled} name="time_limit" ref={register(spaceStates === "reserved" ? { required: true } : { required: false })} />
            {spaceStates === "reserved" ? errors.time_limit && (<span className="error_message">{t("required_information")}</span>) : ""}
          </Form.Field>
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Field required>
            <label>{t("space_passenger")}</label>
            <select aria-expanded="true" name="gender_id" ref={register({ required: true })}
              onChange={(e) => {
                if (!bookingStateCustom.booking.family_room && !bookingStateCustom.reservation.charter &&
                  !bookingStateCustom.reservation.contract_rate && !bookingStateCustom.reservation.ikarus_rate) {
                  handleChancePassengerType(e.target.value)
                }
              }
              }
            >
              <option></option>
              {bookingStateCustom.genders.map((gender) => (
                <option key={gender.id} value={gender.id}>{t(gender.name)}</option>
              ))}
            </select>
            {errors.gender_id && (<span className="error_message">{t("required_information")}</span>)}
          </Form.Field>
          <Form.Field required>
            <label>{t("passenger_nationality")}</label>
            <select aria-expanded="true" name="passenger_nationality" ref={register({ required: true })}>
              <option></option>
              {passengerNationalities.map((nationality, index) => (
                <option key={index} value={nationality.value}>{t(nationality.name)}</option>
              ))}
            </select>
            {errors.passenger_nationality && (<span className="error_message">{t("required_information")}</span>
            )}
          </Form.Field>
          {
            bookingStateCustom.reservation.ikarus_rate &&
            <Form.Field >
              <label>{t("tour_leader")}</label>
              <input type="checkbox"
                name="tour_leader"
                className="mt-[-2px]"
                ref={register}
              />
            </Form.Field>
          }
        </Form.Group>
        {(isChangePassenger !== '' && findRatesState.rates.length > 0) &&
          <>
            <Header as='h3' dividing>{t("select_rate")}</Header>
            <Form.Group className='flex gap-5 mb-8'>
              {
                findRatesState.rates?.map((rate) => (
                  <Form.Field className='flex flex-col gap-3' >
                    <label className='font-semibold'>
                      {
                        rate.airplaneTicket ?
                          t("space_ratePriceInclude")
                          :
                          t("space_ratePriceNotInclude")
                      }
                    </label>
                    <span className="text_date_format uppercase mt-[-14px]">{rate.rateType}</span>
                    <div className="flex flex-col gap-3">
                      <div className="flex gap-3">
                        <label className='font-semibold text-sky-700'>$ {rate.rateClientPrice}</label>
                        <input
                          type="radio"
                          name='rate_id'
                          value={rate.rateId}
                          onClick={hadleChecketTicket}
                          ref={register({ required: findRatesState.rates.length > 0 ? true : false })}
                        />
                      </div>
                      {errors.rate_id && (<span className="error_message mt-[-15px]">{t("required_information")}</span>)}
                    </div>
                  </Form.Field>
                ))
              }
            </Form.Group>
          </>
        }
        <Header as='h3' dividing>{t("general_flight_information_tag")}</Header>
        <Form.Group widths="equal">
          <Form.Field width={1}>
            <label>{t("space_flight_ticket")} </label>
            <div className="ui checkbox mb-3">
              <input autoFocus type="checkbox" name="ticket" ref={register} disabled={checketTicket} />
              <label></label>
            </div>
          </Form.Field>
          <Form.Field width={1}>
            <label>{t("Tour Conductor")} </label>
            <div className="ui checkbox">
              <input autoFocus type="checkbox" name="tour_conductor" ref={register} />
              <label></label>
            </div>
          </Form.Field>
        </Form.Group>
        <Divider variant="middle" />
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Link to={`/cruises/${cruise_id}/reservations/${reservation_id}/bookings/${booking_id}/spaces`}><Button>{t("canceled_button")}</Button></Link>
            <Button primary type="submit" loading={bookingStateCustom.processing ? true : false}>{t("save_button")}</Button>
          </div>
          <div className="flex flex-col uppercase items-center">
            <p className=" text-sky-600 font-semibold text-[20px] m-0">{spaceValue} usd</p>
            <span className="text-[11px] text-gray-400">valor del espacio</span>
          </div>
        </div>


      </Form>
    </>
  );
}
